import React from 'react';
import { mergeProps } from 'next-merge-props';

import { IPage } from '@/types/contentful';

import { getServerSideCategoryProps } from '../../../modules/learning-center/getServerSideCategoryProps';
import { getServerSideCookieProps } from '../../../modules/cookies/getServerSideCookieProps';

import { PageProps } from '../../../context/PageData';

import { Body } from '../../../components/Body';
import { HeroBlock } from '../../../components/Page/HeroBlock';
import { PageBlocks } from '../../../components/Page/PageBlocks';

export default function CategoryPage({ pageData, query }: PageProps) {
  const { fields } = (pageData as IPage) ?? {};

  return (
    <Body {...fields} query={query} bgColor="#F3F3F3">
      <HeroBlock {...fields} />
      <PageBlocks {...fields} />
    </Body>
  );
}

export const getServerSideProps = mergeProps([
  getServerSideCategoryProps,
  getServerSideCookieProps
]);
